
import { IValidate } from "../../interfaces/IValidate";
import { IValidationProperties } from "../../interfaces/IValidationProperties";
import { ValidationResultEnum } from "../enums/ValidationResult";
import { inputResult } from "../helpers/inputResult";
import { ValidationResult } from "../helpers/ValidationResult";

export class NoValidation implements IValidate {
  validationProperties: IValidationProperties;
  constructor(validationProperties: IValidationProperties) {
    this.validationProperties = validationProperties;
  }

  validate(value): inputResult {
    return this.handle({ inputResult: { error: "", value: (value || "") }, validationResult: ValidationResultEnum.SuccessFull });
  }

  handle(result: ValidationResult): inputResult {
    switch (result.validationResult) {
      default: {
        return result.inputResult
      }
    }
  }
}
